import { isEmpty } from 'lodash';

import {
    REQUEST_SUBSCRIBE,
    SUCCESS_SUBSCRIBE,
    FAILURE_SUBSCRIBE,
    RESET_FORM_SUBMIT_SUBSCRIBE
} from './constants';
import { CALL_API } from '../../middlewares/api';
import { updateInfos } from '../account/actions';
import { makeActionCreator } from '../../utils/actionsUtils';
import { HTTP_METHOD_PUT } from '../../constants/httpMethod';

export const ERROR_FORMDATA_EMPTY = 'formData param must not be empty or null or undefined !';

export const reset = makeActionCreator(RESET_FORM_SUBMIT_SUBSCRIBE);

export function sendNewsletterSubscribeRequest(formData, callback) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }
    return {
        [CALL_API]: {
            endpoint: '/user/newsletter/subscription',
            method: HTTP_METHOD_PUT,
            types: [REQUEST_SUBSCRIBE, SUCCESS_SUBSCRIBE, FAILURE_SUBSCRIBE],
            body: formData,
            successCallback: (response, dispatch) => {
                dispatch(updateInfos(response.payload));
                if (callback) {
                    callback();
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/newsletter/actions.js